import { Link } from "@/lib/router-compat";
import type { WeeklyBrief } from "@/services/weeklyBriefService";
import { SectionLabel } from "./SectionLabel";
import { T } from "@/i18n/T";

const fmt = (s: string) =>
  new Date(s).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

export function IssueArchive({ issues, currentId }: { issues: WeeklyBrief[]; currentId?: string }) {
  if (!issues.length) return null;
  return (
    <section className="mt-16 border-t border-border pt-10">
      <SectionLabel><T k="auto.past-issues-6510" /></SectionLabel>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {issues.map((i) => (
          <Link
            key={i.id}
            to={`/weekly/${i.id}`}
            className={`group rounded-2xl border border-border bg-card p-5 transition-colors hover:border-foreground/30 ${
              i.id === currentId ? "opacity-50" : ""
            }`}
          >
            <div className="mb-2 flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
              <span>Issue #{i.issue_number}</span>
              <span>{fmt(i.week_end)}</span>
            </div>
            <div className="line-clamp-3 font-display text-lg leading-snug text-foreground transition-colors group-hover:text-primary">
              {i.headline}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
